import { SkuT } from '@lambda/apis/src/catalog-v2/types';
import { useEffect, useState } from 'react';

const useNewRecommendations = ({
  psku,
  excludeProducts,
}: {
  psku: string | undefined;
  excludeProducts?: string[];
}) => {
  const [products, setProducts] = useState<SkuT[]>([]);
  const [loading, setLoading] = useState(true);

  // An array gets a fresh identity on every render, so the effect keys off a
  // stable string — otherwise it would refetch in a loop.
  const excludeKey = (excludeProducts ?? []).join(',');

  useEffect(() => {
    if (!psku) {
      return;
    }

    const controller = new AbortController();

    const load = async () => {
      try {
        setLoading(true);

        const params = new URLSearchParams({ psku });

        excludeKey
          .split(',')
          .filter(Boolean)
          .forEach((excluded) => params.append('excludeProducts', excluded));

        const res = await fetch(
          `/api/catalog-v2/products/new-recommendations?${params.toString()}`,
          { signal: controller.signal },
        );

        if (!res.ok) {
          throw new Error('Failed to fetch new recommendations');
        }

        const data = await res.json();

        setProducts(data?.items ?? []);
        setLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (err: any) {
        if (err.name !== 'AbortError') {
          setLoading(false);
        }
      }
    };

    load();

    // eslint-disable-next-line consistent-return
    return () => controller.abort();
  }, [psku, excludeKey]);

  return { products, loading };
};

export default useNewRecommendations;
